
import { LayoutDashboard, Users, CreditCard, Settings, CircleUser, BookOpen, FileText, GraduationCap } from "lucide-react";
import React from "react";

export interface NavItem {
  name: string;
  href: string;
  icon: React.ReactNode;
  roles?: Array<'creator' | 'student' | 'any'>;
}

export const navItems: NavItem[] = [
  // Creator routes
  {
    name: "Dashboard",
    href: "/dashboard/creator",
    icon: <LayoutDashboard className="h-5 w-5" />,
    roles: ['creator'],
  },
  {
    name: "My Courses",
    href: "/dashboard/courses",
    icon: <BookOpen className="h-5 w-5" />,
    roles: ['creator'],
  },
  {
    name: "Students",
    href: "/dashboard/students",
    icon: <Users className="h-5 w-5" />,
    roles: ['creator'],
  },
  {
    name: "Sales",
    href: "/dashboard/sales",
    icon: <CreditCard className="h-5 w-5" />,
    roles: ['creator'],
  },
  {
    name: "My Site",
    href: "/dashboard/profile",
    icon: <CircleUser className="h-5 w-5" />,
    roles: ['creator'],
  },
  {
    name: "Settings",
    href: "/dashboard/settings",
    icon: <Settings className="h-5 w-5" />,
    roles: ['creator'],
  },
  
  // Student routes - updated to remove redundant My Learning entry
  {
    name: "Dashboard",
    href: "/dashboard/student",
    icon: <LayoutDashboard className="h-5 w-5" />,
    roles: ['student'],
  },
  {
    name: "My Notes",
    href: "/dashboard/student/notes",
    icon: <FileText className="h-5 w-5" />,
    roles: ['student'],
  },
  {
    name: "Settings",
    href: "/dashboard/student/settings",
    icon: <Settings className="h-5 w-5" />,
    roles: ['student'],
  },
];
